import { SearchInput } from '@synoptic/ui-kit/input/search-input.tsx';
import { useSearchParams } from 'react-router';
import { useSearchInputWithQuery } from './use-search-input-with-query';

export const SearchInputWithQuery = ({
  searchParamsToDelete,
  placeholder,
}: {
  searchParamsToDelete?: string[];
  placeholder?: string;
}) => {
  const [searchParams] = useSearchParams();
  const defaultValue = searchParams.get('q') || '';

  const { onValueChange, value } = useSearchInputWithQuery({
    defaultValue,
    searchParamsToDelete,
  });

  return (
    <SearchInput
      value={value}
      onQueryChange={onValueChange}
      placeholder={placeholder || 'Search'}
    />
  );
};
